import { createSerializer, parseAsInteger, parseAsString } from "nuqs";

// Common navigation parameters
export const fromParser = (defaultValue) =>
  parseAsString.withDefault(defaultValue);
export const productParser = (defaultValue) =>
  parseAsInteger.withDefault(defaultValue);
export const productIdParser = parseAsInteger;
export const tabParser = parseAsString;
export const parentParser = parseAsString;

export const organizationParams = {
  from: fromParser("All Organizations"),
  product: productParser(),
  tab: tabParser,
  productId: productIdParser,
  parent: parentParser,
};

/**
 * Generic serializer for ad-hoc parameters
 * Uses nuqs for proper serialization with all parameter types
 */
const genericParamsSchema = {
  from: fromParser("Back"),
  product: productParser(),
  tab: tabParser,
  productId: productIdParser,
  parent: parentParser,
};

export const serializeParams = createSerializer(genericParamsSchema);
